import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { PostgreSqlLinkedService } from './postgre-sql.linkedservice';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { PostGreSqlAdditionalPropertiesKeyType, SSLMode } from 'app/registries/consts/postgre-consts';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { ParameterConfig } from 'shell-models-lib';
import { LinkedServiceUtils } from './linked-service.utils';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.linkedServiceType : adfModelTypeMap.postgreSqlV2.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.PostgreSql_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.PostgreSql_DisplayText)
    ]
})
export class PostgreSqlV2LinkedService extends PostgreSqlLinkedService {
    public static readonly MODEL: IModel;
    public static readonly SSL_MODE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.SSL_Mode,
        association: 'SSL_MODE',
        templatable: true
    })
    public sslMode: number = SSLMode.Perfer;


    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType = AuthenticationType.Basic;

    public override isLegacyConnector = false;

    public override parameterizableAdditionalFields: Array<ParameterConfig<PostGreSqlAdditionalPropertiesKeyType>>;
    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): PostgreSqlV2LinkedService {
        return LinkedServiceUtils.removePassword(context, this) as PostgreSqlV2LinkedService;
    }
}
